<template>
  <div id="modal-add-task">
    <v-bottom-sheet v-model="isActive" persistent>
      <v-card>
        <div class="modal-header mb-4">
          <p class="title">Nova tarefa</p>
        </div>
        <div class="modal-form">
          <div class="task-type">
            <p>Selecione uma opção</p>
            <v-radio-group v-model="usePackage" row>
              <v-radio label="Tarefa avulsa" :value="false"></v-radio>
              <v-radio label="Pacote de tarefas" :value="true" disabled></v-radio>
            </v-radio-group>
          </div>
          <v-text-field
            v-model="form.description"
            class="mb-4"
            label="Nome da tarefa"
            height="50"
            dense
            hide-details
            outlined
            persistent-placeholder
          ></v-text-field>
          <v-text-field
            v-model="form.estimated_time"
            label="Tempo estimado (hh:mm)"
            append-icon="mdi-clock-outline"
            height="50"
            dense
            hide-details
            outlined
            persistent-placeholder
            type="text"
            v-mask="['##:##']"
          ></v-text-field>
        </div>
        <div class="modal-footer">
          <v-btn class="custom-btn cancel" elevation="0" @click="close">Cancelar</v-btn>
          <v-btn class="custom-btn add" elevation="0" @click="save">Adicionar</v-btn>
        </div>
      </v-card>
    </v-bottom-sheet>
  </div>
</template>

<script>
// TODO: AJUSTAR INPUT DE TEMPO ESTIMADO PARA ACEITAR FORMATO HH:MM
export default {
  name: 'ModalAddTask',
  emits: ['close'],
  props: {
    isActive: {
      type: Boolean,
      required: true
    },
    serviceOrderId: {
      type: Number,
      required: true
    }
  },
  data() {
    return {
      usePackage: false,
      form: {
        description: '',
        estimated_time: ''
      }
    };
  },
  methods: {
    clearForm() {
      this.form = {
        description: '',
        estimated_time: ''
      };
    },
    close() {
      this.clearForm();
      this.$emit('close');
    },
    async save() {
      this.$store.dispatch('ServiceOrderTask/createTask', { serviceOrderId: this.serviceOrderId, body: this.form });
      this.close();
    },
    validateForm() {
      if (!this.form.description || !this.form.estimated_time) {
        this.$toast.error('Preencha todos os campos');
        return false;
      }

      const time = this.form.estimated_time;
      if (!time.match(/^([01]?[0-9]|2[0-3]):[0-5][0-9]$/)) {
        this.$toast.error('Tempo estimado inválido. Use o formato hh:mm');
        return false;
      }

      return true;
    },
    formatTimeInput() {
      const time = this.form.estimated_time;
      if (!time) return;

      const formattedTime = time.replace(/[^0-9]/g, '').slice(0, 4);
      if (formattedTime.length >= 3) {
        this.form.estimated_time = `${formattedTime.slice(0, 2)}:${formattedTime.slice(2, 4)}`;
      } else if (formattedTime.length >= 1) {
        this.form.estimated_time = `${formattedTime.slice(0, 2)}`;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.v-card {
  padding: 16px 16px 24px 16px;

  p {
    margin-bottom: 0;
  }

  .modal-header {
    .title {
      color: #2d3748;
      font-size: 18px;
      font-weight: 600;
      margin-bottom: 0;
      text-align: center !important;
      width: 100%;
    }
  }

  .modal-form {
    display: flex;
    flex-direction: column;

    .task-type {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      .v-input {
        margin-top: 6px;
      }
    }
  }

  .modal-footer {
    display: flex;
    justify-content: space-between;
    margin-top: 18px;

    .custom-btn {
      border-radius: 8px;
      font-size: 16px;
      font-weight: 600;
      height: 40px;
      letter-spacing: 0.3px;
      text-transform: none;
      width: 48%;

      &.add {
        color: #fff;
        background-color: #41a982;
      }

      &.cancel {
        border: 1px solid #e2e8f0;
        background-color: #fff;
        color: #4a5568;
      }
    }
  }
}
</style>
